// проверка загружаемых файлов
export const isUploadFileError = (
  file: File,
): { isError: boolean; message: string } => {
  if (
    file.type !== 'image/jpeg' &&
    file.type !== 'image/png' &&
    file.type !== 'image/jpg'
  ) {
    return {
      isError: true,
      message: 'Разрешенные форматы для загрузки изображений: png, jpeg, jpg.',
    }
  }
  // проверка размера файлов
  if (file.size > 10485760) {
    return {
      isError: true,
      message:
        'Превышен размер загружаемых файлов (максимальный размер файла - 10 Mb).',
    }
  }

  return { isError: false, message: '' }
}
